import { useNotificationsContext } from "./notifications-provider";

export default function useNotifications() {
    return useNotificationsContext()
}
